function Users({ data, onSelectUser }) {
    return (
      <tr className="fw-semibold userTR" onClick={() => onSelectUser(data)} style={{ cursor: "pointer" }}>
        <td>
          <div className="d-flex align-items-center">
            <div
              className="d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold"
              style={{ backgroundColor: "#ffffff0d", width: "32px", height: "32px" }}
            >
              <span>{data.fullname.charAt(0)}</span>
            </div>
            <span className="ms-2 text-nowrap">{data.fullname}</span>
          </div>
        </td>
        <td className="fw-bold">{data.username}</td>
        <td className="fw-bold">{data.currency}</td>
        <td className="fw-bold">{data.country}</td>
        <td className="fw-bold">{(data.address)?data.address:'--'}</td>
        <td className="fw-bold">{data.regdate}</td>
        <td className={`text-${data.verify == "1" ? "success" : "danger"}`}>
          {data.verify == "1" ? "Verified" : "Unverified"}
        </td>
        <td className={`text-${data.deleted == "0" ? "success" : "danger"}`}>
          {data.deleted == "0" ? "Active" : "Blocked"}
        </td>
      </tr>
    );
}

export default Users;